<template>
  <!-- The ad as it now sits in the swipe file, with everything Foreplay
  pulled out of it. Context: adThumbnail, adBrandName, adBrandAvatar -->
  <div>
    <!-- Window header -->
    <div class="flex items-center gap-2 px-3.5 py-2 border-b border-border-normal">
      <SaveAdIcon
        :width="14"
        :height="14"
        class="text-primary-blue-100"
      />
      <BaseText
        type="label"
        size="xs"
        class="text-text-muted"
      >
        Library · Swipe file
      </BaseText>
      <BaseText
        type="body"
        size="xs"
        class="ml-auto text-text-subdued flex-shrink-0"
      >
        1 new
      </BaseText>
    </div>
    <div class="flex items-stretch gap-3 px-3.5 py-3">
      <!-- Ad thumbnail with a saved badge -->
      <div class="scene-ad relative flex-shrink-0 rounded-lg overflow-hidden bg-neutral-50">
        <img
          v-if="thumbnail"
          :src="thumbnail"
          alt=""
          class="w-full h-full object-cover"
        >
        <div
          v-else
          class="w-full h-full scene-ad-placeholder"
        />
        <div class="scene-saved-badge absolute top-1.5 left-1.5 flex items-center gap-1 pl-1 pr-1.5 py-0.5 rounded-full bg-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M4.5 10.5L8 14L15.5 6.5"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="scene-saved-text">Saved</span>
        </div>
      </div>
      <!-- What came with it -->
      <div class="min-w-0 flex-grow flex flex-col">
        <div class="flex items-center gap-1.5">
          <div class="w-4 h-4 rounded-full overflow-hidden flex-shrink-0 bg-neutral-900 flex items-center justify-center">
            <img
              v-if="brandAvatar"
              :src="brandAvatar"
              alt=""
              class="w-full h-full object-cover"
            >
            <ForeplayIcon
              v-else
              :width="10"
              :height="10"
            />
          </div>
          <BaseText
            type="label"
            size="xs"
            class="text-text-loud truncate"
          >
            {{ brandName }}
          </BaseText>
        </div>
        <BaseText
          type="body"
          size="xs"
          class="text-text-subdued mt-1"
        >
          Pulled out of the ad for you:
        </BaseText>
        <div class="flex flex-wrap gap-1 mt-1.5">
          <span
            v-for="(chip, index) in chips"
            :key="chip"
            class="scene-chip flex items-center gap-1 px-1.5 py-0.5 rounded"
            :style="{ animationDelay: `${220 + index * 80}ms` }"
          >
            <span class="scene-chip-dot" />
            <span class="scene-chip-text">{{ chip }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SaveAdIcon from '../../globals/Icons/SaveAdIcon.vue'
import ForeplayIcon from '../../globals/Icons/ForeplayIcon.vue'

export default {
  name: 'AdSavedScene',
  components: {
    SaveAdIcon,
    ForeplayIcon
  },
  props: {
    context: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      chips: ['Transcript', 'AI analysis', 'Landing page', 'Downloads']
    }
  },
  computed: {
    thumbnail () {
      return this.context.adThumbnail || null
    },
    brandName () {
      return this.context.adBrandName || 'Foreplay'
    },
    brandAvatar () {
      return this.context.adBrandAvatar || null
    }
  }
}
</script>

<style scoped>
.scene-ad {
  width: 68px;
  height: 84px;
  box-shadow: 0 2px 8px rgba(6, 7, 16, 0.12);
}
.scene-ad-placeholder {
  background: linear-gradient(160deg, theme('colors.primary.blue-25') 0%, theme('colors.primary.blue-100') 100%);
}
.scene-saved-badge {
  color: theme('colors.primary.green-100');
  box-shadow: 0 1px 3px rgba(6, 7, 16, 0.16);
  animation: scene-badge-in 360ms cubic-bezier(0.34, 1.56, 0.64, 1) both;
  animation-delay: 260ms;
}
.scene-saved-text {
  font-size: 9px;
  font-weight: 600;
  line-height: 12px;
}
.scene-chip {
  background-color: theme('colors.neutral.25');
  animation: scene-chip-in 320ms ease-out both;
}
.scene-chip-dot {
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background-color: theme('colors.primary.blue-100');
}
.scene-chip-text {
  font-size: 10px;
  font-weight: 500;
  line-height: 14px;
  color: theme('colors.neutral.600');
}
@keyframes scene-badge-in {
  from {
    opacity: 0;
    transform: scale(0.6);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes scene-chip-in {
  from {
    opacity: 0;
    transform: translateY(3px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (prefers-reduced-motion: reduce) {
  .scene-saved-badge,
  .scene-chip {
    animation: none;
  }
}
</style>
